import * as React from "react";
const SvgFiRrWifi2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M10 19c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2m8.67-4.65c.4-.38.43-1.01.05-1.41A9.18 9.18 0 0 0 12 10c-2.54 0-4.99 1.07-6.72 2.94a.996.996 0 1 0 1.46 1.36A7.18 7.18 0 0 1 12 12.01c1.99 0 3.9.84 5.26 2.29.2.21.46.32.73.32.24 0 .49-.09.68-.27"
    />
  </svg>
);
export default SvgFiRrWifi2;
